module.exports = __webpack_public_path__ + "img/self_styling_mw_01.f3f05dbb.jpg";